const symbolsIndex = [
  [5, 6, 7, 8, 9],
  [0, 1, 2, 3, 4],
  [10, 11, 12, 13, 14],
  [0, 6, 12, 8, 4],
  [10, 6, 2, 8, 14],
  [5, 11, 12, 13, 9],
  [5, 1, 2, 3, 9],
  [0, 1, 7, 13, 14],
  [10, 11, 7, 3, 4],
];

const wincomb = {
  init({ winTable, scatter, wild }) {
    this.winTable = winTable;
    this.scatter = scatter;
    this.wild = wild;
    this.symbolsIndex = symbolsIndex;
  },

  getWinSymbols(symbols, lines) {
    const winSymbols = this.getWinByLines(symbols, lines)
      .map((win, line) => this.symbolsIndex[line].slice(0, win[1]))
      .reduce((acc, curr) => [...acc, ...curr]);
    return symbols.map((symbol, i) => (winSymbols.includes(i) ? 1 : 0));
  },

  getWin(symbols, lines) {
    const winByLines = this.getWinByLines(symbols, lines);
    const linesWin = winByLines.reduce((acc, curr) => acc + curr[0], 0);
    const scatterLength = symbols.filter(symbol => symbol === this.scatter).length;
    const scatterWin = this.calcWin(this.scatter, scatterLength);

    return {
      scatterLength,
      scatterWin,
      linesWin,
      lines: winByLines.map(win => Math.min(win[0], 1)),
    };
  },

  getWinByLines(symbols, lines) {
    return this.symbolsIndex.map((line, index) => {
      if (lines > index) {
        const symbolsByLine = line.map(i => symbols[i]);
        return this.getWinByLine(symbolsByLine);
      }
      return [0, 0];
    });
  },

  getWinByLine(symbols) {
    const symbol = symbols.find(s => s !== this.wild && s !== this.scatter);
    const symbolLen = symbol === undefined ? 0 : this.countSymbol(symbol, symbols);
    const wildLen = this.countSymbol(this.wild, symbols);

    const wildWin = this.calcWin(this.wild, wildLen);
    const symbolWin = this.calcWin(symbol, symbolLen);
    const realSymbolWin = this.hasWild(symbols, symbolLen) ? symbolWin * 2 : symbolWin;

    if (!wildWin && !realSymbolWin) {
      return [0, 0];
    }

    return wildWin > realSymbolWin ? [wildWin, wildLen] : [realSymbolWin, symbolLen];
  },

  countSymbol(symbol, symbols) {
    const match = symbols[0] === symbol || symbols[0] === this.wild;
    return match ? this.countSymbol(symbol, symbols.slice(1)) + 1 : 0;
  },

  calcWin(symbol, length) {
    const symbolTable = this.winTable[symbol];
    return (symbolTable && symbolTable[length - 1]) || 0;
  },

  hasWild(symbols, length) {
    return symbols.slice(0, length).includes(this.wild);
  },
};

export default wincomb;



// WEBPACK FOOTER //
// ../base/js/managers/wincomb.js